import Vue from 'vue';
import {mapState,mapActions} from 'vuex';
import $ from 'jquery' ;
import http from '../../utils/config';
import Axios from 'axios';
let Base64 = require('js-base64').Base64;
import { PullRefresh } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Uploader } from 'vant';
import { Toast } from 'vant';


Vue.use(Toast);
Vue.use(Uploader);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(PullRefresh);
export default {
  name: 'feedBack',
  data() {
    return {
      disable:true,
      name:'',
      phone:'',
      title:'',
      detail:'',
      radio: '0',
      fileList: [],
      newfile:[]
    };

  },
  updated() {
    if(this.name==''||this.phone=='' ||this.detail==''||this.title==''){
      this.disable=true
    }else{
      this.disable=false
    }
  },
  created() {

  },
  methods: {
    ...mapActions('bot', ['add','postfile']),
    back() {
      this.$router.go(-1)
    },
    afterRead(file) {
      console.log(file,'pp');
      if(file instanceof Array ){
        this.newfile=this.newfile.concat(file);
      }else{
        this.newfile.push(file)
      }
      // 此时可以自行将文件上传至服务器

    },
    beforeRead(file) {
      if(file instanceof Array ){
        for(let i=0;i<file.length;i++){
          if (file[i].type == 'image/jpeg'||file[i].type =='image/png') {
            return true;
          }else{
            Toast('请上传 png/jpg 格式图片');
            return false;
            break;
          }
        }
      }else{
        if (file.type == 'image/jpeg'||file.type =='image/png') {
          return true;
        }
        Toast('请上传 png/jpg 格式图片');
        return false;
      }
    },

    tosuccess(){
      Toast.setDefaultOptions({ duration:60000});
      if(this.flag()){
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        var file=this.newfile;
        console.log(file)
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      for(let i=0;i<file.length;i++){
        formData.append('files', file[i].file);
      }
      //接口需要传的参数
      this.postfile(formData).then(res=>{
        console.log(res.data,'ss');
        var chatAdvice=JSON.stringify({
          chatAdviceUsername:this.name,
          chatAdvicePhone:this.phone,
          chatAdviceContent:this.detail,
          chatAdviceTitle:this.title,
          chatAdviceType:this.radio,
          chatAdviceImg:(res.data!=null&&res.data!="")?res.data+",":res.data,
          // chatAdviceOpenid:"11111",
          chatAdviceOpenid:localStorage.getItem('openId'),
          rebotBelongTo:localStorage.getItem('productCode')
        });
        this.add(chatAdvice).then(res=>{
          Toast.clear();
          if(res.code === 200){
            this.$router.push({name:'successSub'})
          }else{
            Toast(res.msg);
          }
        })
      })
      }

    },
    flag(){
      if(this.name.length<2||this.name.length>30){
        Toast("请输入2-30位的姓名")
        return false
      }else if(!(/^((1[3-9]\d{9})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)$/).test(this.phone)){
        Toast("请输入正确格式的联系电话")
        return false
      }else if(this.title.length<2||this.title.length>50){
        Toast("请输入2-50位的标题")
        return false
      }else if(this.detail<2||this.detail.length>500){
        Toast("请输入2-500位的详细建议")
        return false
      }else{
        return true
      }
    }
  },
};
